import { render, staticRenderFns } from "./BreakTextForm.vue?vue&type=template&id=156de8ca&scoped=true"
import script from "./BreakTextForm.vue?vue&type=script&lang=js"
export * from "./BreakTextForm.vue?vue&type=script&lang=js"
import style0 from "./BreakTextForm.vue?vue&type=style&index=0&id=156de8ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156de8ca",
  null
  
)

export default component.exports